function i(e,...r){return(...t)=>e(...r,...t)}export{i as a};
